<template>
  <v-form
    ref="form"
    v-model="valid"
  >
    <v-row>
      <v-col class="pb-0">
        <v-text-field
          id="user-form-first-name-input"
          dense
          required
          outlined
          label="First Name"
          v-model="model.first_name"
          :rules="rules.first_name"
          @change="updateDefaults"
        />
        <v-text-field
          id="user-form-last-name-input"
          dense
          required
          outlined
          label="Last Name"
          v-model="model.last_name"
          :rules="rules.last_name"
          @change="updateDefaults"
        />
        <v-text-field
          id="user-form-username-input"
          dense
          required
          outlined
          label="Username"
          v-model="model.username"
          :rules="rules.username"
        />
        <v-form ref="passwordSubForm">
          <v-text-field
            v-if="!model.id"
            id="user-form-pwd-input"
            counter
            dense
            required
            outlined
            label="Password"
            v-model="model.password"
            :rules="rules.password"
            :append-icon="hide.password ? 'mdi-eye-off' : 'mdi-eye'"
            :type="hide.password ? 'password' : 'text'"
            @click:append="hide.password = !hide.password"
          />
          <v-text-field
            v-if="!model.id"
            id="user-form-confirm-pwd-input"
            counter
            dense
            required
            outlined
            label="Confirm Password"
            v-model="model.confirm_password"
            :rules="rules.confirm_password.concat(v => (v === model.password || 'Passwords do not match'))"
            :append-icon="hide.confirm ? 'mdi-eye-off' : 'mdi-eye'"
            :type="hide.confirm ? 'password' : 'text'"
            @click:append="hide.confirm = !hide.confirm"
          />
        </v-form>
        <v-text-field
          id="user-form-display-name-input"
          dense
          required
          outlined
          label="Display Name"
          v-model="model.display_name"
          :rules="rules.display_name"
        />
        <v-text-field
          id="user-form-email-input"
          dense
          required
          outlined
          label="Email"
          v-model="model.email"
          :rules="rules.email"
        />
        <v-text-field
          id="user-form-title-input"
          dense
          required
          outlined
          label="Title"
          v-model="model.title"
          :rules="rules.title"
        />
        <v-text-field
          id="user-form-phone-input"
          dense
          required
          outlined
          label="Phone"
          v-model="model.phone"
          :rules="rules.phone"
        />
      </v-col>
      <v-col class="pb-0" cols="8">
        <v-row v-if="model.id">
          <v-col class="py-0">
            <label class="body-1">Active?</label>
            <v-switch
              id="user-form-active-switch"
              class="mt-1"
              v-model="model.active"
              :rules="rules.active"
              :label="model.active ? 'Yes' : 'No'"
            >
            </v-switch>
          </v-col>
          <v-col class="py-0">
            <label class="body-1">Show on App?</label>
            <v-switch
              id="user-form-soa-switch"
              class="mt-1"
              v-model="model.show_on_app"
              :rules="rules.show_on_app"
              :label="model.show_on_app ? 'Yes' : 'No'"
            >
            </v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0">
            <v-skeleton-loader
              class="mx-auto"
              type="text, card-heading"
              v-if="loadingRoles"
            ></v-skeleton-loader>
            <roles-list v-model="model.roles" v-else />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div class="d-flex mb-4">
      <v-spacer />
      <v-btn
        id="user-form-cancel-btn"
        @click="() => $emit('cancel')"
      >
        Cancel
      </v-btn>
      <v-btn
        id="user-form-save-btn"
        :disabled="!valid || error"
        :loading="loading"
        color="primary"
        class="ml-3"
        @click="submit"
      >
        Save
      </v-btn>
    </div>
  </v-form>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import USER_MODEL from './resources/model';
import FORM_RULES from './resources/rules';
import RolesList from '../roles/RoleList';


export default {
  name: 'AdminUsersForm',
  components: {
    RolesList,
  },
  data: () => ({
    model: {},
    hide: {
      password: true,
      confirm: true,
    },
    rules: FORM_RULES,
    valid: false,
    roles: [],
    loading: true,
    loadingRoles: true,
    error: null,
  }),
  computed: {
    informedPassword() {
      return this.model.password;
    },
    informedConfirmPassword() {
      return this.model.confirmPassword;
    },
  },
  methods: {
    setModel(user) {
      this.$refs.form.reset();
      if (user) {
        const mdl = {};
        Object.keys(USER_MODEL).forEach(key => {
          if (key !== 'password' && key !== 'confirm_password') {
            mdl[key] = user[key];
          }
        });
        mdl.id = user._id;
        this.model = mdl;
        this.$nextTick(() => this.getRoles(this.model.id));
      } else {
        const model = {};
        this.model = Object.assign(model, USER_MODEL);
        this.loading = false;
        this.loadingRoles = false;
      }
    },
    updateDefaults() {
      const firstName = this.model.first_name.trim().capitalize();
      const lastName = this.model.last_name.trim().capitalize();
      const username = `${firstName} ${lastName.charAt(0)}`.trim();
      const displayName = username.split(' ').join('');

      this.$set(this.model, 'first_name', firstName);
      this.$set(this.model, 'last_name', lastName);
      this.$set(this.model, 'username', username);
      this.$set(this.model, 'display_name', displayName);
    },
    createUser() {
      this.loading = true;
      const method = this.model.id ? 'put' : 'post';
      const url = this.model.id ? `/v1/users/${this.model.id}` : '/v1/users';
      this.$requests[method](url, this.model)
        .then(() => {
          this.$toast.success('User successfully saved!', { timeout: 3000 });
          this.$emit('success');
        })
        .catch(err => {
          const message = err.response ? err.response.data.message : null;
          this.$toast.error(message || 'Unable to save user...', { timeout: 3000 });
        })
        .then(() => {
          this.loading = false;
        });
    },
    submit() {
      if (!this.$refs.form.validate()) { return; }
      this.createUser();
    },
    getRoles(userId) {
      this.loadingRoles = true;
      this.$requests.get(`/v1/users/${userId}/roles`)
        .then(response => {
          const roles = response.data.map(r => {
            const role = r;
            role.domains = r.domains.map(d => d._id);
            return role;
          });
          this.model.roles = roles;
        })
        .catch(() => {
          this.$toast.error('Could not resolve list of roles...', { timeout: 3000 });
          this.error = true;
        })
        .then(() => {
          this.loadingRoles = false;
        });
    },
  },
  watch: {
    informedPassword() {
      this.$refs.passwordSubForm.validate();
    },
    informedConfirmPassword() {
      this.$refs.passwordSubForm.validate();
    },
  },
  mounted() {
    this.setModel();
  },
};
</script>
